import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="w-full mt-24 bg-emerald-50 dark:bg-emerald-950 flex flex-col items-center justify-center py-20 px-6 no-border space-y-12 font-['Inter']">
      <div className="text-2xl font-bold tracking-tighter text-emerald-900 dark:text-emerald-50">Local Advisor</div>
      <div className="flex flex-wrap justify-center gap-10 text-sm font-medium uppercase tracking-widest">
        <Link className="text-emerald-700/50 hover:text-emerald-900 transition-colors" to="/about">About</Link>
        <Link className="text-emerald-700/50 hover:text-emerald-900 transition-colors" to="/privacy">Privacy</Link>
        <Link className="text-emerald-700/50 hover:text-emerald-900 transition-colors" to="/terms">Terms</Link>
        <Link className="text-emerald-700/50 hover:text-emerald-900 transition-colors" to="/contact">Contact</Link>
      </div>
      <p className="text-emerald-700/50 text-[10px] tracking-widest uppercase font-bold text-center">
        © 2024 Local Advisor. A Digital Curator Production.
      </p>
    </footer>
  );
};

export default Footer;
